module.exports = __webpack_public_path__ + "img/77.452468d7.png";